import PageBody from "../../components/ui/layout/PageBody";

export default function SchedulePage({title, mobileLayoutHeight, children}) {
    return (
        <PageBody mobileLayoutHeight={mobileLayoutHeight} title={title}>
            <div className="space-y-4">
                {children}
            </div>
        </PageBody>
    )
}